export const timelineTheme = {
  itemPaddingBottom: 24,
  margin: 48,
};
